type Tone = "accent" | "orange" | "blue" | "green";

const tones: Record<Tone, string> = {
  accent: "bg-[var(--sf-primary)]",
  orange: "bg-orange-500",
  blue: "bg-sky-500",
  green: "bg-emerald-500",
};

export function ProgressBar({
  progress,
  tone = "accent",
}: {
  progress: number;
  tone?: Tone;
}) {
  const value = Math.max(0, Math.min(1, progress));
  return (
    <div className="h-1.5 w-full overflow-hidden rounded-full bg-[var(--surface-2)]">
      <div
        className={`h-full rounded-full transition-all ${tones[tone]}`}
        style={{ width: `${value * 100}%` }}
      />
    </div>
  );
}
